/**
 * Conferência pública de certificado de treinamento (sem login).
 * O código vem do QR impresso no certificado.
 */
import apiClient from './apiClient';

export interface CertificadoVigente {
  situacao: 'valido' | 'vencido';
  nome: string;
  treinamento: string;
  cargaHoraria: number | null;
  /** AAAA-MM-DD */
  realizadoEm: string;
  /** AAAA-MM-DD */
  validoAte: string;
  empresa: string;
  conferidoEm: string;
}

export interface CertificadoCancelado {
  situacao: 'cancelado';
  treinamento: string;
  conferidoEm: string;
}

export type CertificadoPublico = CertificadoVigente | CertificadoCancelado;

/** O código não existe: único erro que vira "não encontrado". Qualquer outro é falha de conferência. */
export class CertificadoNaoEncontradoError extends Error {
  constructor() {
    super('Certificado não encontrado');
    this.name = 'CertificadoNaoEncontradoError';
  }
}

export const certificadoPublicoService = {
  async conferir(codigo: string): Promise<CertificadoPublico> {
    try {
      // `apiClient.get` já devolve o corpo da resposta; o tipo `ApiResponse<T>` não descreve este DTO
      const corpo = (await apiClient.get(
        `/public/certificados/${encodeURIComponent(codigo)}`
      )) as unknown as CertificadoPublico;
      return corpo;
    } catch (err: unknown) {
      if ((err as { status?: number } | null)?.status === 404) {
        throw new CertificadoNaoEncontradoError();
      }
      throw err;
    }
  },
};
